export default __webpack_public_path__ + "static/logo13-4fbefbd85ed97ac1ba0be67c3f5ba4d3.webp";